import * as React from 'react';
import * as s from 'styled-components';
import { rem } from 'polished';
import { FlexBetween, FlexRowCenterVertical } from './Flexbox/Flexbox';

const styled = s.default;

export interface Props {
  icon: object;
  title: string;
  optional?: any;
  children: any;
  className?: string;
}

export class Box extends React.PureComponent<Props> {
  public static defaultProps = {
    optional: null,
  };

  public render() {
    const { icon, title, optional, children, className } = this.props;
    return (
      <BoxContainer className={className}>
        <BoxHeader>
          <FlexBetween>
            <FlexRowCenterVertical>
              <IconWrapper>{icon}</IconWrapper>
              <Title>{title}</Title>
            </FlexRowCenterVertical>
            <div>{optional}</div>
          </FlexBetween>
        </BoxHeader>
        <BoxContent>{children}</BoxContent>
      </BoxContainer>
    );
  }
}

const BoxContainer = styled.div`
  border: ${({ theme }) => theme.box.mainBorder};
  margin: 10px 0;
  display: flex;
  flex-direction: column;
`;

const BoxHeader = styled.header`
  border-bottom: ${({ theme }) => theme.box.headerBorder};
  padding: 10px;
`;

const IconWrapper = styled.div`
  border-right: ${rem(1)} solid ${({ theme }) => theme.box.iconBorder};
  max-width: ${({ theme }) => theme.box.iconContentWidth};
  padding-right: 20px;
`;

export const BoxContent: any = styled.div`
  padding: ${({ theme }) => theme.box.padding};
  flex-grow: 1;
`;

const Title = styled.h4`
  font-weight: 400;
  font-size: 1.2em;
  padding-left: 10px;
  color: ${({ theme }) => theme.box.boxTitle};
`;
